// Function to animate counters
function animateCounter(counter) {
    const target = parseFloat(counter.getAttribute("data-target")); // Convert target to a float
    const speed = 100; // Adjust speed
    const increment = target / speed;
    let current = 0;

    const formatNumber = (num) => {
        // Format number with commas and retain two decimal places if needed
        return num.toLocaleString("en-IN", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
    };

    const updateCount = () => {
        if (current < target) {
            current += increment;
            counter.textContent = formatNumber(Math.min(current, target));
            requestAnimationFrame(updateCount);
        } else {
            counter.textContent = formatNumber(target); // Ensure the final value matches the target
        }
    };

    updateCount();
}

// Intersection Observer callback
function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            const counters = entry.target.querySelectorAll(".customer-insights-grid-count .count");
            counters.forEach((counter) => animateCounter(counter));
            observer.unobserve(entry.target); // Stop observing after animation
        }
    });
}

// Create an Intersection Observer
const observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.5, // Trigger when 50% of the section is visible
});

// Observe the customer insight section
const insightSection = document.querySelector(".cutomer-insights-section");
if (insightSection) {
    observer.observe(insightSection);
}


